import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMaterialIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		stroke: "none",
		d: "m12 3 9 9-9 9-9-9Z"
	})
});
export default SvgMaterialIcon;
